export enum PrePostingLabelStatus {
  Pending = 0,
  Processing = 1,
  Ready = 2,
  Failed = 3
};
